var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationRolesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72px",
    height: "73px",
    viewBox: "0 0 72 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4.041 50.04h24.33a3.04 3.04 0 0 1 3.04 3.041v15.206a3.042 3.042 0 0 1-3.04 3.041H4.04A3.042 3.042 0 0 1 1 68.287V53.081a3.04 3.04 0 0 1 3.041-3.041zM67.906 71.328h-24.33a3.04 3.04 0 0 1-3.04-3.041V34.834a3.038 3.038 0 0 1 3.04-3.041h24.33a3.038 3.038 0 0 1 3.04 3.041v33.453a3.04 3.04 0 0 1-3.04 3.041zM67.906 22.668h-24.33a3.04 3.04 0 0 1-3.04-3.041V4.42a3.04 3.04 0 0 1 3.04-3.041h24.33a3.04 3.04 0 0 1 3.04 3.041v15.206a3.04 3.04 0 0 1-3.04 3.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    strokeLinejoin: "round",
    d: "M4.041 1.38h24.33a3.042 3.042 0 0 1 3.04 3.041v33.453a3.042 3.042 0 0 1-3.04 3.041H4.04A3.042 3.042 0 0 1 1 37.874V4.42A3.042 3.042 0 0 1 4.041 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 39h13M47 46h10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationRolesLarge);
export default __webpack_public_path__ + "static/media/application-roles-large.68ad8369d5761f9a68d62275e477e3e8.svg";
export { ForwardRef as ReactComponent };